module.exports = __webpack_public_path__ + "static/media/qualitative-research.4d984ffa.svg";